import S from './big-heading.styles';

export const BigHeading = S.StyledBigHeading;
